var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"footer_text"},[_c('p',[_vm._v("聯合線上公司 製作權所有 "),(!_vm.isWeb)?_c('br'):_vm._e(),_vm._v("© udn.com All Rights Reserved.")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }